exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "/* hide the outline for the HotKeys component */\ndiv[tabindex='-1']:focus {\n  outline: none;\n}\n", "", {"version":3,"sources":["/app/client/src/templates/Challenges/components/hotkeys.css"],"names":[],"mappings":"AAAA,gDAA+C;AAC/C;EACE,cAAa;CACf","file":"hotkeys.css","sourcesContent":["/* hide the outline for the HotKeys component */\ndiv[tabindex='-1']:focus {\n  outline: none;\n}\n"],"sourceRoot":""}]);

// exports
